import { useSelector } from 'react-redux';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
// import MainAppBar from '../navigation/MainAppBar';
// import MainBottomNavigation from '../components/ui/mainBottomNavigation';
import { hasAccess } from '../helpers/roles';
import Loader from '../components/ui/loader';
import ContactButton from '../components/ui/contact';
import { getHighestAvailableUrl } from '../helpers/urlHelper';

export default function PrivateRoute({ allowedRoles }) {
  const location = useLocation();

  const { isAuthenticated, user, loading, loggingOut } = useSelector((state) => state.auth);

  const userRole = user?.role;

  const landingUrl = getHighestAvailableUrl(userRole);

  // Improved auth/loading messaging
  if (loading || loggingOut) {
    let message = 'Please wait...';

    if (loggingOut) message = 'See you soon...';
    else if (loading) message = 'Processing...';

    return <Loader loading message={message} />;
  }

  // Not logged in
  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  // Role check
  if (allowedRoles && !hasAccess(userRole, allowedRoles)) {
    return <Navigate to={landingUrl} replace />;
  }

  return (
    <>
      {/* <MainAppBar /> */}

      <div style={{ minHeight: 'calc(100vh - 140px)' }}>
        <Outlet />
      </div>

      {location.pathname !== '/contact' && <ContactButton />}

      {/* <MainBottomNavigation /> */}
    </>
  );
}
